import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Custom
import TenantContext, { TenantContextType } from '@/context/TenantContext/TenantContext';

const UpitnikNaslov = () => {
  const { t } = useTranslation();
  const tenantContext = useContext(TenantContext) as TenantContextType;
  const theme = tenantContext?.tenantTheme;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
      <Typography variant="h5" component="h1">
        {t('groblja:upitnik.title')}
      </Typography>
      {theme?.crest ? (
        <Box
          component="img"
          src={`data:${theme.crest_type || 'image/png'};base64,${theme.crest}`}
          alt=""
          sx={{ height: 36, width: 'auto', flexShrink: 0 }}
        />
      ) : null}
    </Box>
  );
};

export default UpitnikNaslov;
